<template>
  <book-my-bookings 
    :content="data"
    :config="config"
    :locale="locale"
    :isDesktop="false"
  />
</template>

<script>
import { mapState } from 'vuex'
import utils from '@/services/utils'
import BookMyBookings from './BookMyBookings'
export default {
  components: {
    BookMyBookings,
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: null,
    },
  },
  data: () => ({
    config: {

    }
  }),
  computed: {
    ...mapState('app', ['locale', 'FontContent', 'FontSizeContent', 'ColorContent']),
  },
  watch: {
  },
  mounted () {
  }
}
</script>
<style scoped>
</style>

